import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "AIzaSyCnFX8x3ceJ-vwAoRXHqG4RNWVMku66aWE",
//   authDomain: "testing-c58d2.firebaseapp.com",
//   projectId: "testing-c58d2",
//   storageBucket: "testing-c58d2.appspot.com",
//   messagingSenderId: "951398600923",
//   appId: "1:951398600923:web:01cce3e47dbae62b477cfe",
// };

const firebaseConfig = {
  apiKey: "AIzaSyBPc5IsS7v31zxlmqmxi0JhqRo1Tv1Bu6k",
  authDomain: "corsa-e48d8.firebaseapp.com",
  projectId: "corsa-e48d8",
  storageBucket: "corsa-e48d8.appspot.com",
  messagingSenderId: "741768838463",
  appId: "1:741768838463:web:b45efb69586bcd592be78a",
  measurementId: "G-1R75NE6EK9",
};
export const messagingKey =
  "BBaq-VPTScpIbZBT1-6ZHoOSjxCypPYeQWpU3hGDUE8D2MPWxpf4tJvrFbCIU32jpIE_i_3Q_HfHgQv2nM_bifY";
// "BIgAgJmNekgiWa9TMOWyfcrGpvb6NwLyZeKFPYTyioxcleNoTekefCOnH9zu181uwRoggxpTgynpX07c7BuWTkI";
export const isMessgingSupported = isSupported();
const firebaseApp = initializeApp(firebaseConfig);
export const messaging = isMessgingSupported ? getMessaging(firebaseApp) : null;
